import React, { useState } from 'react';
import { Button, Col, Form, message, Modal, Row, Skeleton } from 'antd';

import FormInput from 'components/FormInput/FormInput';
import FormSelection from 'components/FormSelection/FormSelection';
import SectionCard from 'components/SectionCard/SectionCard';

const { useForm } = Form;
const { confirm } = Modal;

const AddSourceModal = ({ isLoading, visible, onClose, onOk, onRemove, defaultValues, types }) => {
  const [form] = useForm();
  const [selectedType, setSelectedType] = useState('');

  const handleOnOkButtonClick = async e => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach(field => message.error(field.errors[0]));
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: 'Do you want to remove this?',
      okText: 'Yes',
      onOk() {
        onRemove();
      },
      onCancel() {}
    });
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          Remove
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          Save this source
        </Button>
      ]
    : [
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          Add this source
        </Button>
      ];

  return (
    <Modal title="Cash Inflow Source Details" visible={visible} onOk={handleOnOkButtonClick} onCancel={onClose} footer={footer} width="60%">
      <Form form={form} initialValues={defaultValues}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Row gutter={16}>
            <Col span={24}>
              <FormSelection
                label="Source"
                name="type"
                placeholder="Select a type"
                requiredErrorMessage="Please select a source type."
                selections={types}
                extraProps={{
                  onChange: value => setSelectedType(value)
                }}
              />
            </Col>
            {selectedType === 'otherIncome' && (
              <Col span={24}>
                <FormInput label="Label" name="label" placeholder="Enter a label for policy type" requiredErrorMessage="Please enter for label policy type." />
              </Col>
            )}
            <Col span={12}>
              <SectionCard title="Self">
                <FormInput label="Amount" name={['amount', 'self']} placeholder="0.00" type="financial" requiredErrorMessage="Please enter amount of this source." />
              </SectionCard>
            </Col>
            <Col span={12}>
              <SectionCard title="Spouse">
                <FormInput label="Amount" name={['amount', 'spouse']} placeholder="0.00" type="financial" />
              </SectionCard>
            </Col>
          </Row>
        )}
      </Form>
    </Modal>
  );
};

export default AddSourceModal;
